// Content for the v3 portfolio — ported from "Mohsin Idrees Portfolio v3.dc.html"

export const socials = [
  {
    label: "LINKEDIN",
    value: "linkedin.com/in/mohsinidrees-",
    href: "https://www.linkedin.com/in/mohsinidrees-",
    icon: "M6.94 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM5 8h4v12H5zM10 8h4v1.9c.7-1.1 2-2.2 4-2.2 3.1 0 4.4 2 4.4 5.5V20h-4v-6c0-1.6-.6-2.6-1.9-2.6-1 0-1.6.7-1.9 1.4-.1.2-.1.6-.1 1V20h-4z",
  },
  {
    label: "GITHUB",
    value: "github.com/mohsinidrees2817",
    href: "https://github.com/mohsinidrees2817",
    icon: "M12 2a10 10 0 0 0-3.16 19.49c.5.1.68-.22.68-.48v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.46-1.16-1.11-1.47-1.11-1.47-.9-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.9 1.52 2.34 1.08 2.91.83.09-.65.35-1.08.63-1.33-2.22-.25-4.56-1.11-4.56-4.95 0-1.1.39-1.99 1.03-2.69-.1-.26-.45-1.29.1-2.69 0 0 .84-.27 2.75 1.02a9.6 9.6 0 0 1 5 0c1.9-1.29 2.75-1.02 2.75-1.02.55 1.4.2 2.43.1 2.69.64.7 1.03 1.59 1.03 2.69 0 3.85-2.34 4.7-4.57 4.94.36.31.68.92.68 1.85v2.74c0 .27.18.58.69.48A10 10 0 0 0 12 2z",
  },
  {
    label: "UPWORK",
    value: "Top Rated Plus",
    href: "https://www.upwork.com/freelancers/~01990863ba7110b5a9",
    icon: "M18.56 5.87c-2.15 0-3.8 1.42-4.47 3.7-.62-1.68-1.26-3.3-1.26-3.3H9.98v6.8c0 1.36-.66 2.4-2.02 2.4s-2.02-1.04-2.02-2.4V6.27H3.09v6.8c0 3.14 2.05 5.06 4.87 5.06 2.42 0 4.16-1.48 4.7-3.66.36 1.05.62 1.87.62 1.87.7 2 .13 3.55-2.5 3.55-.4 0-.86-.05-1.34-.13l-.5 2.8c.66.15 1.5.24 2.16.24 4.44 0 5.9-2.87 4.55-6.72l-.5-1.4c.5.55 1.24.88 2.17.88 2.35 0 3.98-1.85 3.98-4.58s-1.63-4.61-3.14-4.61zm-.1 6.4c-1 0-1.8-.9-2-2.13.2-1.5 1-2.5 2-2.5 1.14 0 1.9.98 1.9 2.32 0 1.34-.76 2.31-1.9 2.31z",
  },
  {
    label: "EMAIL",
    value: "contact@mohsin-idrees.com",
    href: "mailto:contact@mohsin-idrees.com",
    icon: "M2 5.5A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18.5zM4.7 5l7.3 6 7.3-6zM4 7.2V18.5c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5V7.2l-7.6 6.24a1 1 0 0 1-1.28 0z",
  },
  {
    label: "WEBSITE",
    value: "mohsin-idrees.com",
    href: "https://mohsin-idrees.com",
    icon: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm7.94 9h-3.1a15.8 15.8 0 0 0-1.28-5.6A8.03 8.03 0 0 1 19.94 11zM12 4.06c.9 1.2 1.98 3.2 2.24 6.94H9.76c.26-3.74 1.34-5.74 2.24-6.94zM9.76 13h4.48c-.26 3.74-1.34 5.74-2.24 6.94-.9-1.2-1.98-3.2-2.24-6.94zM8.44 5.4A15.8 15.8 0 0 0 7.16 11h-3.1a8.03 8.03 0 0 1 4.38-5.6zM4.06 13h3.1a15.8 15.8 0 0 0 1.28 5.6A8.03 8.03 0 0 1 4.06 13zm11.5 5.6A15.8 15.8 0 0 0 16.84 13h3.1a8.03 8.03 0 0 1-4.38 5.6z",
  },
];

export const badges = ["5+ years", "Top Rated Plus (Upwork)", "100+ projects delivered"];

const logos = ["EMUMBA", "OGDCL", "UPWORK — TOP RATED PLUS", "STRUCTURA", "SIGNEO", "TECHTRIBE"];
export const logosLoop = [...logos, ...logos];

export const stats = [
  { num: 5, suffix: "+", label: "YEARS EXPERIENCE" },
  { num: 100, suffix: "+", label: "PROJECTS DELIVERED" },
  { num: 100, suffix: "%", label: "JOB SUCCESS — UPWORK" },
];

export const services = [
  { num: "S.01", glyph: "{ }", title: "Scalable SaaS Products", desc: "End-to-end SaaS builds. Multi-tenant platforms that go from MVP to production with auth, real-time features, and room to scale." },
  { num: "S.02", glyph: "~>", title: "AI Automation & Agentic Workflows", desc: "Agentic AI and automation pipelines that remove slow, manual work from your operations." },
  { num: "S.03", glyph: "[Δ]", title: "System Design & Architecture", desc: "Architecture sized to your requirements: latency budgets, real-time pipelines, dual runtimes, and patterns that stay fast under load." },
  { num: "S.04", glyph: "◆", title: "AI Chatbots & RAG", desc: "Assistants grounded in your own docs, with citations, built on LangChain and modern LLMs." },
  { num: "S.05", glyph: "λ", title: "AWS & Serverless Backends", desc: "Lambda, API Gateway, DynamoDB, S3, Cognito, and Bedrock deployments that scale on demand." },
  { num: "S.06", glyph: "</>", title: "Business Websites & E-Commerce", desc: "Complete business websites, portals, and storefronts. CMS-driven, responsive, and built to convert." },
];

export const skillGroups = [
  {
    label: "Frontend",
    count: "10 TOOLS",
    items: ["React", "Next.js", "Vite", "TypeScript", "JavaScript", "HTML", "CSS", "Tailwind CSS", "Framer Motion", "Three.js"],
  },
  {
    label: "Backend",
    count: "08 TOOLS",
    items: ["Node.js", "Express", "Python", "FastAPI", "Django", "Socket.IO", "REST APIs", "Serverless APIs"],
  },
  {
    label: "AI / LLM",
    count: "12 TOOLS",
    items: ["OpenAI", "Anthropic (Claude)", "DeepSeek", "Groq", "LangChain", "LangSmith", "RAG pipelines", "Vector embeddings", "Agentic workflows", "Prompt engineering", "Web scraping", "Data cleaning"],
  },
  {
    label: "AWS / Cloud",
    count: "50+ SERVICES",
    items: ["Lambda", "S3", "EC2", "DynamoDB", "API Gateway", "Cognito", "CloudFront", "RDS", "SQS / SNS", "Bedrock", "Amazon Q", "CloudWatch", "CloudFormation", "…50+ more"],
  },
  {
    label: "Databases",
    count: "07 TOOLS",
    items: ["PostgreSQL", "MongoDB", "Pinecone", "Chroma", "Firebase", "Supabase", "GridFS"],
  },
  {
    label: "Dev Tools & CI/CD",
    count: "07 TOOLS",
    items: ["Git / GitHub", "GitHub Actions (CI/CD)", "Docker", "Postman", "Vercel", "DigitalOcean", "Figma"],
  },
  {
    label: "System Design",
    count: "06 AREAS",
    items: ["Scalable SaaS architecture", "Multi-tenant systems", "Real-time systems (WebSockets)", "Dual-runtime architectures", "Serverless patterns", "API & schema design"],
  },
];

export const experience = [
  { dates: "2024 — NOW", role: "Full-Stack AI Developer", company: "Freelance · Upwork", location: "Remote", desc: "Full-stack apps with custom LLM chatbots for diverse clients; scalable serverless architectures on AWS." },
  { dates: "2023 — 2024", role: "AWS GenAI Engineer", company: "Emumba", location: "Onsite", desc: "GenAI solutions on AWS; full-stack apps, chatbot pipelines, and agentic workflows." },
  { dates: "JUL — SEP 2023", role: "Full-Stack AI Developer", company: "OGDCL", location: "Onsite", desc: "Built the FLT program website; integrated an AI chatbot (LangChain) for policy queries." },
  { dates: "2021 — 2023", role: "Full-Stack Developer", company: "TechTribe Dev", location: "Onsite", desc: "Responsive, fast websites; serverless features on AWS (S3, Lambda, API Gateway)." },
];

export const featured = {
  title: "Structura",
  desc: "A full-lifecycle SaaS for authoring, collaborating on, and managing EU funding applications. It has an AI writing assistant, RAG chat, streaming validation, and real-time collaboration over Socket.IO. I led the build for 12 months and it runs live in production.",
  tech: ["Next.js 15", "FastAPI", "LangChain", "Pinecone", "Socket.IO"],
  link: "/work/structura",
};

// caseStudy links are internal routes rendered by Pages/ProjectCaseStudy
export const projects = [
  {
    num: "P.02",
    live: false,
    title: "SmartChat",
    desc: "No-code SaaS to create, deploy, and monitor AI chatbots trained on your own data, with a RAG pipeline, four deployment methods, and a real-time analytics dashboard.",
    tech: ["Next.js", "LangChain", "Pinecone"],
    caseStudy: "/work/smartchat",
    homeFeatured: true,
  },
  {
    num: "P.03",
    live: false,
    title: "DocuMind",
    desc: "Enterprise AI knowledge assistant with cited answers over complex policy documents. An ML classifier routes each query to a FAQ engine or a full RAG pipeline.",
    tech: ["LangChain", "RAG", "MongoDB"],
    caseStudy: "/work/documind",
    homeFeatured: true,
  },
  {
    num: "P.04",
    live: true,
    title: "RebHub",
    desc: "A complete real-estate ecosystem: a public property portal with an AI chatbot, backed by a full CRM for leads, listings, agents, and sales pipelines.",
    tech: ["Next.js", "Node.js", "MongoDB"],
    caseStudy: "/work/rebhub",
    homeFeatured: true,
    liveUrl: "https://rebhub-web-client.vercel.app/",
  },
  {
    num: "P.05",
    live: false,
    title: "SignalCast",
    desc: "Real-time voice AI that transcribes and translates spoken video audio, then drives a 3D sign-language avatar live inside the frame.",
    tech: ["Python", "Groq", "Three.js"],
    caseStudy: "/work/signalcast",
    homeFeatured: true,
  },
  {
    num: "P.06",
    live: true,
    title: "Yarns & Wools",
    desc: "Three-portal e-commerce ecosystem with a consumer storefront, a brand self-service portal, and a super admin panel, all on one Firebase backend with real-time inventory.",
    tech: ["Next.js", "TypeScript", "Firebase"],
    caseStudy: "/work/yarns-and-wools",
    homeFeatured: true,
    liveUrl: "https://www.yarnsandwool.com/",
  },
  {
    num: "P.07",
    live: false,
    title: "Amazon Q Knowledge Base",
    desc: "Enterprise chatbot over company knowledge, secured with Cognito and deployed on EC2.",
    tech: ["Amazon Q", "Cognito", "EC2"],
  },
  {
    num: "P.08",
    live: false,
    title: "Aigenty",
    desc: "Real-estate listing platform with an AI property-search chatbot.",
    tech: ["Next.js", "FastAPI", "Azure", "MLS API"],
  },
  {
    num: "P.09",
    live: true,
    title: "SaleBag",
    desc: "E-commerce marketplace with brand listings, discounts, and a full shopping flow.",
    tech: ["Cognito", "DynamoDB"],
    liveUrl: "https://salebag-2-0.vercel.app/",
  },
  {
    num: "P.10",
    live: true,
    title: "Future Leaders Team",
    homeFeatured: true,
    desc: "Website for OGDCL's FLT program with an integrated AI chatbot (LangChain) for policy queries.",
    tech: ["React", "LangChain", "RAG"],
    liveUrl: "https://flt-2-0.vercel.app/",
  },
  {
    num: "P.11",
    live: true,
    title: "Info Homes",
    desc: "Real-estate insights platform where property decisions are powered by data.",
    tech: ["Next.js", "MongoDB"],
    liveUrl: "https://infohomes.vercel.app/",
  },
  {
    num: "P.12",
    live: true,
    title: "Refer To Agency",
    desc: "Referral platform to recommend services, track referrals, and earn commissions.",
    tech: ["Next.js", "Node.js"],
    liveUrl: "https://refer-to-agency.vercel.app/",
  },
  {
    num: "P.13",
    live: true,
    title: "TechTribe",
    desc: "Agency website for the development and design studio where I started out.",
    tech: ["React", "Tailwind CSS"],
    liveUrl: "https://techtribe.vercel.app/",
  },
  {
    num: "P.14",
    live: false,
    title: "Axum Forge",
    desc: "Design, technology, and AI solutions studio. My own product-and-services venture.",
    tech: ["Next.js", "Tailwind CSS"],
  },
  {
    num: "P.15",
    live: false,
    title: "Abbasi Developers",
    desc: "Business website for a property development company.",
    tech: ["React", "Tailwind CSS"],
  },
  {
    num: "P.16",
    live: true,
    title: "ImageConvert",
    desc: "Free in-browser image conversion tool. Fast, private, no uploads.",
    tech: ["React"],
    liveUrl: "https://imageconverter.vercel.app/",
  },
];

export const testimonials = [
  {
    quote: "I've truly enjoyed working with you over the past year. You are not only a genuinely kind and thoughtful person, but also an outstanding professional. I honestly couldn't have asked for a better colleague to work with.",
    name: "Claes Lundin",
    role: "Founder, Structura",
    tag: "STRUCTURA · EU-GRANT SAAS",
  },
  {
    quote: "Mohsin's work was outstanding in quality, but his level of commitment and responsibility went far beyond expectations. He tackled the challenge head-on, communicated proactively, and handled pressure like a pro. This wasn't just good work, it was exceptional. If you're lucky enough to have the chance to work with him, don't think twice. (10/5 stars if I could!)",
    name: "Alejo Amaya",
    role: "Founder, Signeo",
    tag: "SIGNEO · PRODUCT BUILD",
  },
  {
    quote: "Mohsin did an amazing job of integrating Amplify in my environment (Docker, micro-services…). I highly recommend him, and I will definitely continue working with him on other topics. I was amazed by the quality, speed, and adaptability that he showed me.",
    name: "Majd Najih",
    role: "Technical Project Manager",
  },
  {
    quote: "Mohsin consistently delivers full-stack engineering work of exceptional quality, demonstrating a deep understanding of both frontend and backend technologies. His proactive problem-solving is standout and I would highly recommend him to anyone seeking top-tier development talent.",
    name: "Jacob Ojoie",
    role: "Founder, TJ Jacobs",
    tag: "TJ JACOBS · FULL-STACK BUILD",
  },
  {
    quote: "Mohsin is a gem of a developer. Understands requirements and fills in the gaps without too much oversight. Delivers on time and exactly as needed. Will definitely rehire him!",
    name: "Rashid",
    role: "Senior DevOps Engineer · USA",
  },
  {
    quote: "Mohsin is a true professional. A rare find, hardworking and eager to solve any wrinkles or deployment issues. He is willing to explore various methods and spend the time and energy to find a solution. Will happily hire him for future projects.",
    name: "Rashid",
    role: "Senior DevOps Engineer · repeat client",
  },
  {
    quote: "Been working with Mohsin for some time on several projects. Always delivers great value, super easy to work with!",
    name: "Mike",
    role: "Founder, AIgenty · Canada",
  },
  {
    quote: "Mohsin was extremely quick and helpful. He helped us solve our AWS issues and taught our developer how to do it for future events. Amazing to work with.",
    name: "Shawn Krantz",
    role: "Tarzan · USA",
  },
  {
    quote: "Job completed successfully and to my full satisfaction. Mohsin was communicative, quick to respond, and very professional. The code was clean and well-commented, and when fixes were needed they were performed quickly. Thank you very much, Mohsin.",
    name: "John Bannon",
    role: "Philadelphia · USA",
  },
];

export const typedWords = ["available_for_projects", "open_to_freelance", "shipping_ai_products"];
